import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-bestheader',
  templateUrl: './bestheader.component.html',
  styleUrls: ['./bestheader.component.css']
})
export class BestheaderComponent implements OnInit {
  language: any = [];

  constructor(public translateService: TranslateService
              ) { }

  ngOnInit() {
    this.translateService.use('en');
  }


}
